import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type OttopilotEvent = {
    additionalColumnValues: Record<Uuid, unknown>;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    eventContainerId: Uuid;
    id: Uuid;
    /** Optional notes column denormalized onto the row by API responses. */
    notes?: unknown;
    revisionId: Uuid;
    status: OttopilotEventStatus;
    templateId: Uuid;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
};

export enum OttopilotEventStatus {
    active = "a05471b5-72e3-47e9-8928-1859cc8b41fa",
    archived = "a0daff30-5854-4b04-a722-b913d157086c",
}

export const ottopilotEventValidator = zod.strictObject({
    additionalColumnValues: zod.record(uuidZodValidator, zod.unknown()),
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    eventContainerId: uuidZodValidator,
    id: uuidZodValidator,
    notes: zod.unknown().optional(),
    revisionId: uuidZodValidator,
    status: zod.enum(OttopilotEventStatus),
    templateId: uuidZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
}) satisfies zod.ZodType<OttopilotEvent>;

export type OttopilotEventCudLog = OttopilotEvent;

export const ottopilotEventCudLogValidator: zod.ZodType<OttopilotEventCudLog> = ottopilotEventValidator;
